<template>
  <div class="site-footer">
    <p class="font-primary mb-4">
     Created with 💖 by
      <a href="https://www.github.com/nisargp08" target="_blank"
        >Nisarg Patel</a
      >
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
$tailwind-color: #21d0ee;
$theme-color: #6366f1;
$text-gray-200: rgba(229, 231, 235, 1);

.site-footer {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  text-align: center;
  margin-top: 4rem;
  padding: 1rem;
  padding-bottom: 0;
  border-top: 1px solid $text-gray-200;

  a {
    color: $theme-color;
  }

  .tailwind {
    color: $tailwind-color;
  }
}
</style>
